module.exports = __webpack_public_path__ + "img/image.a532fac0.png";